import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from 'vue';
import { store } from '@/store/index';
import { dispatchRemoveNotification } from '@/store/main/actionsMain';
import { commitRemoveNotification } from '@/store/main/mutations';
import { AppNotification } from '@/store/main/state';
import sharedMessages from '@/lib/shared-messages';
import { i18n } from '@/plugins/vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseNotificationsManager',
  setup(__props) {

const $t = i18n.t.bind(i18n);

// State
const show = ref(false);
const showProgress = ref(false);
const currentNotification = ref<AppNotification | null>(null);
const snackbarKey = ref(0);

// Methods
const hideSnackbar = async (): Promise<void> => {
  show.value = false;
  await new Promise((resolve) => setTimeout(resolve, 500));
};

const handleClose = async (): Promise<void> => {
  await hideSnackbar();
  await removeNotification();
};

const removeNotification = async (): Promise<void> => {
  if (currentNotification.value) {
    commitRemoveNotification(store, currentNotification.value);
  }
};

const updateNotification = (notification: AppNotification | null): void => {
  currentNotification.value = notification;
  showProgress.value = notification?.showProgress ?? false;
  show.value = Boolean(notification);
  snackbarKey.value += 1; // Increment key to force re-render
};

const notificationContent = computed(() => {
  const content = currentNotification.value?.content;
  const messageKey = currentNotification.value?.messageKey;
  if (messageKey) {
    const values = currentNotification.value?.messageValues;
    return $t(messageKey, values);
  }
  return content || '';
});
const notificationColor = computed(
  () => currentNotification.value?.color || 'info'
);

// Watcher
let watcherVersion = 0;
watch(
  () => store.state.main.notifications[0],
  async (newNotification: AppNotification | null) => {
    if (newNotification !== currentNotification.value) {
      const myVersion = ++watcherVersion;
      await hideSnackbar();
      if (myVersion !== watcherVersion) return;
      updateNotification(newNotification);
      if (newNotification) {
        dispatchRemoveNotification(store, {
          notification: newNotification,
          timeout: 20000,
        });
      }
    }
  },
  { immediate: true }
);

return { __sfc: true,$t, show, showProgress, currentNotification, snackbarKey, hideSnackbar, handleClose, removeNotification, updateNotification, notificationContent, notificationColor, watcherVersion, sharedMessages }
}

})